/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_QuestionInputs */

const en_us2_onboarding_how_heard_question = /** @type {(inputs: Onboarding_How_Heard_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How did you hear about us?`)
};

const pt_br2_onboarding_how_heard_question = /** @type {(inputs: Onboarding_How_Heard_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como você nos conheceu?`)
};

const es_419_onboarding_how_heard_question = /** @type {(inputs: Onboarding_How_Heard_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo nos conociste?`)
};

const pt_pt2_onboarding_how_heard_question = /** @type {(inputs: Onboarding_How_Heard_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como nos conheceste?`)
};

const fr_fr2_onboarding_how_heard_question = /** @type {(inputs: Onboarding_How_Heard_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment nous as-tu connus ?`)
};

const de_de2_onboarding_how_heard_question = /** @type {(inputs: Onboarding_How_Heard_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie hast du von uns erfahren?`)
};

const it_it2_onboarding_how_heard_question = /** @type {(inputs: Onboarding_How_Heard_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come ci hai conosciuto?`)
};

/**
* | output |
* | --- |
* | "How did you hear about us?" |
*
* @param {Onboarding_How_Heard_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_question = /** @type {((inputs?: Onboarding_How_Heard_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_question(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_question(inputs)
	return en_us2_onboarding_how_heard_question(inputs)
});
export { onboarding_how_heard_question as "onboarding.how_heard.question" }